import styled from '@emotion/styled';

export const Description = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.color.grey500};
    font-size: 14px;
    line-height: 1.4;
`;

export const ToggleRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;
    padding: 16px;
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: 8px;
`;

export const ToggleHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;
`;

export const SwitchWrapper = styled.div`
    flex-shrink: 0;
`;

export const ToggleLabel = styled.span`
    font-weight: 600;
    line-height: 1.4;
`;
